import { defineMessages } from 'react-intl';

export default defineMessages({
  batchNumber: {
    description: 'advancedSearch.shipments.filters.batchNumber',
    defaultMessage: 'Batch #',
    id: 'RYpwrj',
  },
  carrier: {
    description: 'advancedSearch.shipments.filters.carrier',
    defaultMessage: 'Carrier',
    id: 'Fq5tvN',
  },
  country: {
    description: 'advancedSearch.shipments.filters.country',
    defaultMessage: 'Country',
    id: 'tpcvIK',
  },
  createdBy: {
    description: 'advancedSearch.shipments.filters.createdBy',
    defaultMessage: 'Created By',
    id: 'wymAO1',
  },
  createdDate: {
    description: 'advancedSearch.shipments.filters.createdDate',
    defaultMessage: 'Created Date',
    id: '+xMCGi',
  },
  deliveryStatus: {
    description: 'advancedSearch.shipments.filters.deliveryStatus',
    defaultMessage: 'Delivery Status',
    id: 'zpVkQK',
  },
  fulfillmentType: {
    description: 'advancedSearch.shipments.filters.fulfillmentType',
    defaultMessage: 'Category',
    id: 'b4TTTu',
  },
  notes: {
    description: 'advancedSearch.shipments.filters.notes',
    defaultMessage: 'Notes (contains)',
    id: 'hrCcbs',
  },
  orderNumber: {
    description: 'advancedSearch.shipments.filters.orderNumber',
    defaultMessage: 'Order #',
    id: 'xjqxCT',
  },
  recipient: {
    description: 'advancedSearch.shipments.filters.recipient',
    defaultMessage: 'Recipient',
    id: 'kmlRH1',
  },
  returnReceived: {
    description: 'advancedSearch.shipments.filters.returnReceived',
    defaultMessage: 'Return Received',
    id: '4DWNU6',
  },
  returningParty: {
    description: 'advancedSearch.shipments.filters.returningParty',
    defaultMessage: 'Returning Party',
    id: 'HYuEXn',
  },
  rmaNumber: {
    description: 'advancedSearch.shipments.filters.rmaNumber',
    defaultMessage: 'RMA #',
    id: 's3SHG/',
  },
  selectOne: {
    description: 'advancedSearch.shipments.filters.selectOneOption',
    defaultMessage: 'Select One...',
    id: 'EwCu16',
  },
  shipDate: {
    description: 'advancedSearch.shipments.filters.shipDate',
    defaultMessage: 'Ship Date',
    id: 'NMW0yl',
  },
  shipFrom: {
    description: 'advancedSearch.shipments.filters.shipFrom',
    defaultMessage: 'Ship From Location',
    id: 'cIZTUg',
  },
  submissionDate: {
    description: 'advancedSearch.shipments.filters.submissionDate',
    defaultMessage: 'Submission Date',
    id: '12wd2a',
  },
  trackingNumber: {
    description: 'advancedSearch.shipments.filters.trackingNumber',
    defaultMessage: 'Tracking #',
    id: 'YgpgYd',
  },
});
